import { render, staticRenderFns } from "./SupplierListFilters.vue?vue&type=template&id=8ff9951a&"
import script from "./SupplierListFilters.vue?vue&type=script&lang=js&"
export * from "./SupplierListFilters.vue?vue&type=script&lang=js&"
import style0 from "./SupplierListFilters.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports